<template>
    <div class="geometric-search" v-if="show" @click="GeometricSearch">
        <img :src="url" alt="">
        <span>几何搜索</span>
    </div>
</template>

<script>
import {DomainService} from '@/libs'

export default {
    data() {
        return {
            url: `${DomainService.PublicPath}resource/images/icon/jihe.png`,
            show: false,
        }
    },
    mounted() {
        const geometric = sessionStorage.getItem('geometric');
        if (geometric && Number(geometric) == 1) this.show = true;
    },
    methods: {
        GeometricSearch() {
            window.formium.postMessage("GeometricSearch", "JavaScript");
        }
    }
}
</script>

<style lang="less" scoped>
    .geometric-search{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 18px;
        color: @main-color;
        cursor: pointer;
        position: absolute;
        right: 120px;
        top: -2px;
        z-index: 999;
        img{
            height: 23px;
            margin-bottom: 4px;
        }
    }
</style>
